export default __webpack_public_path__ + "static/media/login-register.f2696d8f.png";